/**
 * KAN-646: compact one-line formats for the clients table.
 */

/**
 * Russian phone as "+7 915 501-32-01". Accepts "+79155013201", "79155013201",
 * "89155013201" and formatted input; anything else is returned as is.
 */
export function formatClientPhone(phone: string | null | undefined): string {
  if (!phone) return '';
  const digits = phone.replace(/\D/g, '');
  if (digits.length !== 11 || !/^[78]/.test(digits)) return phone;
  const n = digits.slice(1);
  return `+7 ${n.slice(0, 3)} ${n.slice(3, 6)}-${n.slice(6, 8)}-${n.slice(8, 10)}`;
}

const pad = (value: number): string => String(value).padStart(2, '0');

/**
 * Date and time in one line: "02.10 15:13"; the year is added only when it
 * differs from the current one ("02.10.2025 15:13"). Local time zone.
 */
export function formatClientActivity(
  value: string | null | undefined,
  now: Date = new Date()
): string {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const day = `${pad(date.getDate())}.${pad(date.getMonth() + 1)}`;
  const year = date.getFullYear() === now.getFullYear() ? '' : `.${date.getFullYear()}`;
  return `${day}${year} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
